export default "__VITE_ASSET__CjaHjSqB__"